import React from 'react'
import OperacionesCallesDeCalado from '../components/callesDeCalado/OperacionesCallesDeCalado'

export const COLUMNS_CALLE_CALADO = [
  {
    name: 'numero',
    label: 'Calle',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'cerealAsignado',
    label: 'Cereal asignado',
    options: {
      filter: true,
      filterType: 'checkbox',
      sort: true
    }
  },
  {
    name: 'capacidad',
    label: 'Capacidad',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'ocupado',
    label: 'Ocupado',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'libre',
    label: 'Disponible',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'entry',
    label: 'Primer camión',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (entry) => {
        const camion = entry.camionPrimero ? `${entry.camionPrimero} - ${entry.cerealPrimero} - ${entry.calificacionCerealPrimero}` : ' '
        return camion
      }
    }
  },
  {
    name: 'entry',
    label: 'Último camión',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (entry) => {
        const camion = entry.camionUltimo ? `${entry.camionUltimo} - ${entry.cerealUltimo} - ${entry.calificacionCerealUltimo}` : ' '
        return camion
      }
    }
  },
  {
    name: 'habilitado',
    label: 'Habilitado',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'entry',
    label: ' ',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (entry) => {
        return <OperacionesCallesDeCalado calle={entry} />
      }
    }
  }
]
